/* eslint-disable react/forbid-prop-types */
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import { A } from 'components/common/Link/Link'
import { ServiceIcon } from 'components/common/ServiceIcon'
import * as UI from '../../../Common.styles'
import PhoneLink from 'components/common/PhoneLink'
import RemoveItemButton from '../RemoveItemButton'
import CartItem from '../CartItem'
import { CALL_STORE_FOR_PRICE_FIRST_TEXT } from 'constant'

const ServiceItem = ({
  className,
  enableEdit,
  service: {
    available,
    commerceItemId,
    iconName,
    image,
    name,
    price,
    qty,
    serviceId,
    totalPrice
  },
  serviceGTMData,
  storePhoneNumber = '',
  formattedStorePhoneNumber = '',
  showStoreLocatorModalInAppointmentMode,
  myStore,
  handleTAOSDateTimeUpdate,
  ...props
}) =>
  <UI.ItemWrapper className={ className } { ...props }>
    <CartItem>
      <Cell serviceIcon>
        <ImageWrapper>
          <ServiceIcon iconName={ iconName } full />
        </ImageWrapper>
        <Title>
          { name }
        </Title>
      </Cell>
      <Cell>
        <UI.Mobile service>Quantity</UI.Mobile>
        <Quantity>{ qty }</Quantity>
        {
          enableEdit &&
          <RemoveItemButton service GTMData={ serviceGTMData } commerceItemId={ commerceItemId } />
        }
      </Cell>
      {/* Services will not have pricing for phase 1  */}
      {/* totalPrice ?
        <Fragment>
          <UI.Mobile service>Total Price</UI.Mobile>
          <Cell>
            <Price>$ { totalPrice }</Price>
          </Cell>
        </Fragment> */}
      <Cell>
        {/* Empty cell TODO: Needs a css variant */}
      </Cell>
      <Cell>
        <UI.Mobile service>Total Price</UI.Mobile>
        <CallStore>
          { CALL_STORE_FOR_PRICE_FIRST_TEXT }
          {
            !myStore ?
              <Fragment>
                <StoreLink prevent to="/" bolder handler={ () => showStoreLocatorModalInAppointmentMode(handleTAOSDateTimeUpdate) }>
                  Select a Store
                </StoreLink>
              </Fragment> :
              <Fragment>
                <Media.Mobile>
                  <StyledPhoneLink number={ storePhoneNumber } />
                </Media.Mobile>
                <Media.Desktop>
                  <Phone>{ formattedStorePhoneNumber }</Phone>
                </Media.Desktop>
              </Fragment>
          }
        </CallStore>
      </Cell>
    </CartItem>
  </UI.ItemWrapper>

ServiceItem.propTypes = {
  className: PropTypes.string,
  enableEdit: PropTypes.bool,
  formattedStorePhoneNumber: PropTypes.string,
  handleTAOSDateTimeUpdate: PropTypes.func,
  myStore: PropTypes.shape(),
  service: PropTypes.shape({
    available: PropTypes.any,
    commerceItemId: PropTypes.any,
    iconName: PropTypes.any,
    image: PropTypes.any,
    name: PropTypes.any,
    price: PropTypes.any,
    qty: PropTypes.any,
    serviceId: PropTypes.any,
    totalPrice: PropTypes.any
  }),
  serviceGTMData: PropTypes.shape(),
  showStoreLocatorModalInAppointmentMode: PropTypes.func,
  storePhoneNumber: PropTypes.string
}

export default ServiceItem

const Cell = styled.div`
  vertical-align: top;
  ${Media.desktop`
    display: table-cell;
  `}
  ${props => props.definedWidth && css`
    ${Media.desktop`
      width: 165px;
    `}
    ${Media.mobile`
      width: 90%;
    `}
  `}
  ${Media.desktop`
    ${props => props.right && css`
      text-align: right;
    `}
  `}
  ${Mixin.responsive('padding', '30px 3px', '0 0 10px')}
  ${props => props.serviceIcon && css`
    ${Mixin.responsive('padding', '30px 3px 30px 23px', '0 0 10px')}
  `}
  ${Mixin.clearFix()}
  ${props => props.disabled && css`
    opacity: 0.5;
  `}

  &:last-child {
    ${Media.desktop`
      width: ${props => props.long ? '315px' : '150px'};
      padding-right: 20px;
    `}
    ${Media.mobile`
      padding: 0;
    `}
  }
`
// Services will not have pricing for phase 1

// const Price = styled.span`
//   font-weight: 600;
//   color: ${Theme.colors.sub_grey};
//   ${Mixin.responsive('line-height', '22px', '19px')}
// `

const CallStore = styled.div`
  font-weight: 600;
  line-height: 22px;
  ${Media.desktop`
    margin-top: 27px;
  `}
`

const StoreLink = styled(A)`
  display: block;
  font-weight: 600;
  ${Mixin.responsive('line-height', '22px', '19px')}
`

const Title = styled.div`
  display: inline-block;
  color: ${Theme.colors.sub_grey};
  vertical-align: top;
  width: 65%;
  ${Media.desktop`
    margin-top: 8px;
  `}
  ${Mixin.responsive('padding-left', '24px', '16px')}
  ${Mixin.font.GothamBold(18, 600, 24)}
`

const Quantity = styled.div`
  font-weight: 600;
  ${Media.mobile`
    display: inline-block;
    vertical-align: middle;
  `}
  ${Mixin.responsive('margin-top', '31px', '13px')}
`

const StyledPhoneLink = styled(PhoneLink)`
  display: block;
  font-weight: 600;
  line-height: 22px;
`

const Phone = styled.div`
  font-weight: 600;
  line-height: 22px;
`

const ImageWrapper = styled.div`
  float: left;
  position: relative;
  text-align: center;
  border: 1px solid ${Theme.colors.light_grey};
  max-width: 144px;
  ${Mixin.responsive('float', 'left', 'none')}
  ${Mixin.responsive('width', '30%', '60px')}
  ${Mixin.responsive('padding', '20px', '15px')}
  ${Mixin.middle()}
  ${Media.mobile`
    display: inline-block;
  `}
`
